// Phase 21 · Participant tile (video grid — no camera feed, avatar placeholder)
import React from "react";
import { MicOff, Crown, Camera, CameraOff } from "lucide-react";

export default function ParticipantTile({ p, spotlight = false, isHostView, onToggleMute }) {
    const isHost = p.role === "host";
    const size = spotlight ? "aspect-video sm:aspect-[16/9]" : "aspect-square";

    return (
        <div
            className={`relative rounded-xl overflow-hidden border ${spotlight ? "border-[#FAFAFA]/40" : "border-[#1A1A1A]"} bg-gradient-to-br from-[#111111] to-[#111111] ${size} group`}
            data-testid={`video-tile-${p.user_id}`}
        >
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
                <div className={`rounded-full bg-white flex items-center justify-center text-neutral-900 font-bold ${spotlight ? "w-20 h-20 text-3xl" : "w-14 h-14 text-xl"}`}>
                    {p.username?.[0]?.toUpperCase() || "?"}
                </div>
                <p className="text-xs text-neutral-300 font-semibold">@{p.username}</p>
                <p className="text-[9px] text-neutral-500 uppercase tracking-widest">{p.role}</p>
            </div>
            <div className="absolute top-2 left-2 flex items-center gap-1">
                {isHost && (
                    <div className="bg-[#A3A3A3] rounded-full p-1">
                        <Crown size={10} className="text-white" />
                    </div>
                )}
            </div>
            <div className="absolute bottom-2 right-2 flex items-center gap-1">
                {p.is_muted_ui ? (
                    <div className="bg-[#FAFAFA] rounded-full p-1">
                        <MicOff size={10} className="text-white" />
                    </div>
                ) : null}
                <div className="bg-[#FAFAFA]/30 rounded-full p-1" title="Camera off (V4 placeholder)">
                    <CameraOff size={10} className="text-[#FAFAFA]" />
                </div>
            </div>
            {isHostView && !isHost && (
                <div className="absolute inset-x-2 bottom-2 hidden group-hover:flex justify-center">
                    <button
                        type="button"
                        onClick={() => onToggleMute?.(p)}
                        className="text-[10px] px-2 py-1 rounded-lg bg-[#0A0A0A]/80 border border-[#1A1A1A] hover:border-[#A3A3A3]/40 hover:text-[#A3A3A3] text-neutral-300"
                    >
                        {p.is_muted_ui ? "Unmute" : "Mute"}
                    </button>
                </div>
            )}
        </div>
    );
}
